<template>
  <div>
    <navbar />
    <nuxt-child :site-name="name" />
    <section v-if="$route.path === '/'" class="section is-small">
      <div class="container">
        <loan-application />
      </div>
    </section>
    <lazy-hydrate ssr-only>
      <footer-comp logo="false" />
    </lazy-hydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'

export default {
  components: {
    LazyHydrate,
    footerComp: () => import( '~/whitelabels/components/footer' ),
    loanApplication: () => import( '~/components/businessApplication' ),
    navbar: () => import( '~/whitelabels/components/navbar' )
  },
  layout: 'whitelabel',
  data () {
    return {
      name: 'Yrityslainavertailut',
      domain: 'yrityslainavertailut.com'
    }
  },
  head () {
    const desc = `Yrityslainavertailut auttaa sinua löytämään lainan useilta eri pankeilta ja rahoituslaitoksilta.
      Laske laina sinulle sopivalla kuukausierällä.`
    const theme = '#6610f2'
    return {
      title: `${this.name} | Lainahakemus`,
      meta: [
        { hid: 'description', name: 'description', content: desc },
        { hid: 'og:title', name: 'og:title', property: 'og:title', content: this.name },
        { hid: 'og:site_name', name: 'og:site_name', property: 'og:site_name', content: this.name },
        { hid: 'og:description', name: 'og:description', property: 'og:description', content: desc },
        { hid: 'apple-mobile-web-app-title', name: 'apple-mobile-web-app-title', content: this.name },
        { hid: 'theme-color', name: 'theme-color', content: theme }
      ],
      link: [{ rel: 'icon', type: 'image/x-icon', href: require( '~/assets/whitelabels/yrityslainavertailut/favicon.png' ) }]
    }
  }
}
</script>

<style lang="scss">
@import "~assets/whitelabels/scss/_variables.scss";

$wl-primary: #3385d9;
$wl-secondary: #fff;

$wl-body-background: #f7f7f7;

$wl-body-background: $wl-primary;
$wl-navbar-background: #fff;
$wl-body-background: url('~assets/whitelabels/yrityslainavertailut/background.jpeg');

$wl-navbar-item-color: white;
$wl-navbar-logo-height: 4rem;

$wl-footer-background: #222;
$wl-footer-color: #fff;

$wl-button-background: #FF6700;

@import "~assets/whitelabels/scss/styles.scss";

.whitelabel.yrityslainavertailut {
  @include whitelabel;

  .navbar-item {
    text-transform: uppercase;
  }
}
</style>
